import React, { useEffect } from 'react'
import Banner from './Banner';
import "./landingPage.css"
import OfferRibbon from '../../components/OfferRibbon';
import Laptop from '../../components/Laptop';
import Floater from '../../components/Floaters/Floater';
import WorldMap from './WorldMap';
import InvestersSection from './InvestersSection';
import FaqSection from './FAQ_Section';
import Footer from '../../Layout/Footer';
import Navbar from '../../Layout/NavBar';
import JoinRibbon from '../../components/JoinRibbon';
import HowitWorks from './howitWorks/HowitWorks';
import FeatureSection from './featureSection/FeatureSection';
import TestimonialSection from './testimonialSection/TestimonialSection';
import Languages from './languages/Languages';
import axios from 'axios';
import { useSelector } from 'react-redux';
function LandingPage() {
  const fbp = useSelector(state => state.fb?.fbp)
  const fbc = useSelector(state => state.fb?.fbc)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    
    const generate_fb_viewContentEvent= async ()=>{
      const body = {
        event_source_url: window.location.href,
        browser_id: fbp,
        click_id: fbc
        // opt_out: false
      }
      await axios.post(process.env.REACT_APP_SERVER+"/api/v1/fb-event/view-conten",body)
      .then((res)=>{
        console.log(res.data?.message);
      })
      .catch((err)=>{
        console.error(err.data?.message);  
      })
    }
    if(fbp) generate_fb_viewContentEvent()
  }, [fbp])





  
  
  
  return (
    <div className='landingPage'>
        <Navbar type={1}  />
        <div className='content'>
        {/* <OfferRibbon /> */}
        {/* <Floater /> */}
            <Banner />
            <Laptop />
            <FeatureSection />
            <Languages />
            <HowitWorks />
            <WorldMap />
            <TestimonialSection />
            <FaqSection />
            <Footer />
        </div>
        <JoinRibbon />

    </div>
  )
}

export default LandingPage;